import { VaiIcon } from '@vaisala/rockhopper-design-tokens';
import { Form } from '../Form/Form.js';
import { Label } from '../Label/Label.js';
import { Button, ButtonType } from '../Button/Button.js';
import { Size } from '../../constants.js';
import * as React from 'react';
import { Icon } from '../Icon/Icon.js';
import { Anchor } from '../Anchor/Anchor.js';
import { PasswordInput } from '../PasswordInput/PasswordInput.js';

class PasswordForm extends React.Component {
  constructor() {
    super(...arguments);
    this.passwordInput = null;
  }
  componentDidMount() {
    if (this.passwordInput !== null) {
      this.passwordInput.focus();
    }
  }
  render() {
    const {
      dataTa,
      onSubmit,
      onPasswordChange,
      onBack,
      passwordLabel,
      password,
      forgotPasswordURL,
      forgotPasswordLabel,
      nextButtonLabel,
      username,
      backButtonLabel,
      className
    } = this.props;
    return /* @__PURE__ */ React.createElement(Form, {
      preventDefault: true,
      onSubmit,
      dataTa,
      className
    }, /* @__PURE__ */ React.createElement(Button, {
      buttonType: ButtonType.Link,
      className: "vai-padding-none vai-login__back-button",
      startIcon: /* @__PURE__ */ React.createElement(Icon, {
        name: VaiIcon.ArrowLeft
      }),
      onClick: onBack,
      tabIndex: 0
    }, backButtonLabel || ""), username !== void 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Label, {
      htmlFor: "username",
      className: "vai-margin-top-m"
    }, username), /* @__PURE__ */ React.createElement("input", {
      style: { display: "none" },
      name: "username",
      defaultValue: username,
      "aria-hidden": "true",
      autoComplete: "username"
    })), /* @__PURE__ */ React.createElement(Label, {
      htmlFor: "password",
      className: "vai-margin-top-m"
    }, passwordLabel), /* @__PURE__ */ React.createElement(PasswordInput, {
      name: "password",
      spellCheck: false,
      value: password,
      width: Size.Container,
      onChange: onPasswordChange,
      autoComplete: "current-password",
      tabIndex: 0,
      innerRef: (input) => {
        this.passwordInput = input;
      }
    }), /* @__PURE__ */ React.createElement("div", {
      className: "vai-margin-top-s",
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }
    }, /* @__PURE__ */ React.createElement(Anchor, {
      to: forgotPasswordURL
    }, forgotPasswordLabel), /* @__PURE__ */ React.createElement(Button, {
      type: "submit"
    }, nextButtonLabel)));
  }
}

export { PasswordForm };
